export class OrderAttachmentDto {
  id = 0;
  orderId = 0;
  fileName = '';
  fileSize = 0;
  file: File | null = null;
  blobUrl = '';
  createdDate: Date | null = null;
  enteredBy = '';
}